// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"37ae0af2","72":"d3330773","477":"4f301910","627":"78eae37c","663":"aa566f73","667":"b61231f7","777":"c789e99c","803":"adec2b06","820":"00b399ea"}[chunkId] + ".chunk.js";
};